var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00216 0C4.03812 0 0 4.0338 0 8.99784C0 11.3877 0.935856 13.5632 2.46096 15.1762C4.10346 16.9136 6.42798 18 9.00216 18C13.9662 18 18 13.9619 18 8.99784C18 4.0338 13.9662 0 9.00216 0ZM9.00216 1.125C13.358 1.125 16.875 4.64202 16.875 8.99784C16.875 10.7212 16.3238 12.3131 15.3886 13.6089C14.7122 11.7013 13.1807 10.1959 11.2464 9.52938C12.1542 8.84524 12.7427 7.75892 12.7427 6.53976C12.7427 4.47966 11.0615 2.79414 9.00211 2.79414C6.94201 2.79414 5.26009 4.47953 5.26009 6.53976C5.26009 7.75897 5.85 8.84538 6.75774 9.52938C4.82274 10.1952 3.28788 11.7 2.61072 13.6075C1.67557 12.3123 1.12502 10.7204 1.12502 8.99784C1.12502 4.64202 4.64616 1.125 9.00216 1.125ZM9.00216 3.91986C10.4541 3.91986 11.6177 5.08846 11.6177 6.54048C11.6177 7.99243 10.4541 9.15606 9.00216 9.15606C7.55021 9.15606 6.38514 7.9924 6.38514 6.54048C6.38514 5.08853 7.55023 3.91986 9.00216 3.91986ZM9.00216 10.2811C11.7261 10.2811 13.9662 12.1387 14.5139 14.6264C13.095 16.0179 11.1508 16.875 9.00216 16.875C6.85404 16.875 4.90932 16.0186 3.48894 14.6286C4.03598 12.1403 6.27678 10.2811 9.00216 10.2811Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.c2c9bcee3c76857a85b4094c0fc01484.svg";
export { ForwardRef as ReactComponent };